import React from "react";
import { Doughnut } from "react-chartjs-2"; // Change to Doughnut
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

const InterviewPieChart = ({ dataPoints }) => {
  // Define color mapping for emotions
  const colorMapping = {
    happy: "rgb(44, 160, 44)", // green
    neutral: " rgb(31, 119, 180)", // blue
    serious: "rgb(255, 127, 14) ", // orange
    others: "rgb(214, 39, 40)", // red
    "No Face Detected": "black",
    "Multiple Faces Detected": "#9ca3af",
  };

  const hoverColorMapping = {
    happy: "rgb(35, 128, 35)", // dark green
    serious: "rgb(204, 102, 11)", // dark orange
    others: "rgb(171, 31, 32)", // dark red
    neutral: "rgb(25, 95, 144)", // dark blue
    "No Face Detected": "#333333",
    "Multiple Faces Detected": "#6b7280",
  };

  // Aggregate data
  // const aggregatedData = dataPoints.reduce((acc, emotion) => {
  //   if (acc[emotion.label]) {
  //     acc[emotion.label] += emotion.value;
  //   } else {
  //     acc[emotion.label] = emotion.value;
  //   }
  //   return acc;
  // }, {});

  // Aggregate data by counting occurrences of analysis texts
  const aggregatedData = dataPoints?.reduce((acc, dataPoint) => {
    const analysis = dataPoint?.label || "Unknown"; // Extract and handle undefined analysis
    if (acc[analysis]) {
      acc[analysis] += 1; // Increment the count for the analysis
    } else {
      acc[analysis] = 1; // Initialize the count for a new analysis
    }

    return acc;
  }, {});

  let labels = [];
  let values = [];
  if (aggregatedData) {
    labels = Object.keys(aggregatedData);
    values = Object.values(aggregatedData);
  }

  const emotionData = {
    labels: labels,
    datasets: [
      {
        data: values,
        backgroundColor: labels.map(
          (label) => colorMapping[label] || "#000000"
        ),
        hoverBackgroundColor: labels.map(
          (label) => hoverColorMapping[label] || "#333333"
        ),
        borderWidth: 0,
      },
    ],
  };

  // Calculate total value for percentage calculation
  const totalValue = values?.reduce((sum, value) => sum + value, 0);

  // Create a custom legend
  const customLegend = labels
    ?.map((label, index) => {
      const value = values[index];
      const percentage = ((value / totalValue) * 100).toFixed(2);
      return { label, value, percentage: parseFloat(percentage) };
    })
    .sort((a, b) => b.percentage - a.percentage) // Sort by percentage (descending)
    .map(({ label, percentage }) => (
      <div
        key={label}
        className="flex items-center justify-between space-x-2 w-full"
      >
        <div className="flex gap-2 items-center">
          <div
            className="w-4 h-4 rounded-full"
            style={{ backgroundColor: colorMapping[label] || "#000000" }}
          ></div>
          <div className="text-[#475467]">{label}</div>
        </div>
        <span>
          <span className="text-[#101828] font-medium">{percentage}%</span>
        </span>
      </div>
    ));

  return (
    <>
      {dataPoints && (
        <div className="w-full mt-8 flex flex-col md:flex-row gap-x-10 lg:gap-x-20 gap-y-6 justify-center items-center">
          <div className="h-[295px]">
            <Doughnut
              data={emotionData}
              options={{
                responsive: true,
                plugins: {
                  legend: {
                    display: false,
                  },
                  tooltip: {
                    backgroundColor: "white",
                    displayColors: false,
                    bodyColor: "black",
                    bodyFont: {
                      size: "14px",
                      family: "Inter, sans-serif",
                    },
                    padding: 9,
                    callbacks: {
                      label: function (tooltipItem) {
                        return tooltipItem.label;
                      },
                      title: function () {
                        return "";
                      },
                    },
                  },
                },
                cutout: "50%",
              }}
            />
          </div>
          {/* Custom legend */}
          <div className="w-[80%] xs:w-[70%] sm:w-[50%] md:w-[35%] lg:w-[30%] 2xl:w-[21%]">
            <div className="text-[#101828] font-semibold text-[1.175rem]">
              Dominant Expressions
            </div>
            <div className="mt-[.6rem] flex flex-col gap-[.4rem]">
              {customLegend}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InterviewPieChart;
